import { defineStore } from 'pinia'
//import Router from "@/router/index.js";
//import apiClient from "@/apiClient";

export let useBreadcrumbStore = defineStore('breadcrumb', {
  state() {
    return {
      value: '',
      policyPath: [],
    }
  },

  actions: {
    setValue(val) {
      this.value = val
    },
    setPolicyPath(path) {
      this.policyPath = Array.isArray(path) ? path : []
    },
    clearValue() {
      this.value = ''
    },
    clearPolicyPath() {
      this.policyPath = []
    },
  },

  getters: {
    getValue() {
      return this.value
    },
    getPolicyPath() {
      return this.policyPath
    },
  },
})
